import React from 'react'
import { useSelector } from 'react-redux'
import stylesIndex from '../../../css/Index.module.css'
import UpdateLicenses from '../../../components/ServerPreferences/UpdateLicenses'

export default function Server () {
  const user = useSelector((state) => state.user)
  const role = user.roles

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`} style={{ flexDirection: 'column', justifyContent: 'space-between' }}>
        {role?.preferencesServerPage.viewLicensesMdm && <div className={`content  ${stylesIndex.mainContent}`}>
          <UpdateLicenses user={user}/>
        </div>}
    </div>
  )
}
